import React from 'react';
import { Stack } from 'expo-router';

import { DEFAULT_SCREEN_OPTIONS } from '../../options';

// ─────────────────────────────────────────────────────────────────────────────

export default function AccountTabLayout() {
  return <Stack screenOptions={DEFAULT_SCREEN_OPTIONS} />;
}
